import { render, staticRenderFns } from "./ActTwelveFloat.vue?vue&type=template&id=95abb5c4&scoped=true&"
import script from "./ActTwelveFloat.vue?vue&type=script&lang=js&"
export * from "./ActTwelveFloat.vue?vue&type=script&lang=js&"
import style0 from "./ActTwelveFloat.vue?vue&type=style&index=0&id=95abb5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95abb5c4",
  null
  
)

export default component.exports